import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton
} from "@mui/material";
import { useTranslation } from "react-i18next";

import PersonalTab from "./PersonalTab";
import AvatarSelection from "./AvatarSelection";
import LearningPreferenceTab from "./LearningPreferenceTab";
import SecurityTab from "./SecurityTab";
import NotificationsTab from "./NotificationsTab";
import FeedbackTab from "./FeedbackTab";
import LogoutDialog from "./LogoutDialog";
import PrivacyComponent from "ui/components/shared/PrivacyComponent";

const SettingsTabs = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(0);
  const [logoutOpen, setLogoutOpen] = useState(false);

  const tabs = [
    { label: t("Personal"), component: <PersonalTab /> },
    { label: t("Learning Preferences"), component: <LearningPreferenceTab /> },
    { label: t("Avatar Selection"), component: <AvatarSelection /> },
    { label: t("Notifications"), component: <NotificationsTab /> },
    { label: t("Security"), component: <SecurityTab /> },
    { label: t("Feedback"), component: <FeedbackTab /> },
    { label: t("Imprint & Privacy"), component: <PrivacyComponent  />},
    { label: t("Logout"), component: null }, // handled separately
  ];

  const handleTabClick = (index: number) => {
    if (tabs[index].label === t("Logout")) {
      setLogoutOpen(true);
    } else {
      setSelectedTab(index);
    }
  };

  return (
    <Box display="flex" height="100%" width="100%" minHeight="500px">
      {/* Sidebar */}
      <Box
        width="240px"
        bgcolor="#F8F9F8"
        borderRight="1px solid #d0d0d0"
        padding="1rem 0"
      >
        <List disablePadding>
          {tabs.map((tab, index) => (
            <ListItemButton
              key={index}
              selected={selectedTab === index}
              onClick={() => handleTabClick(index)}
              sx={{
                borderLeft: selectedTab === index
                  ? "4px solid #7e9c86"
                  : "4px solid transparent",
                backgroundColor: selectedTab === index ? "#ffffff" : "transparent",
                padding: "0.75rem 1.5rem",
                "&:hover": {
                  backgroundColor: "#eef1ee",
                },
              }}
            >
              <Typography fontWeight={600}>
                {tab.label}
              </Typography>
            </ListItemButton>
          ))}
        </List>
      </Box>

      <Box flex={1} padding="2rem" overflow="auto">
        {tabs[selectedTab].component}
      </Box>

      <LogoutDialog open={logoutOpen} onClose={() => setLogoutOpen(false)} />
    </Box>
  );
};

export default SettingsTabs;
